import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { GameProvider, useGame } from './context/GameContext';
import StarfieldBackground from './components/three/StarfieldBackground';
import Header from './components/Header';
import MissionPanel from './components/MissionPanel';
import FleetPanel from './components/FleetPanel';
import StationPanel from './components/StationPanel';
import InventoryPanel from './components/InventoryPanel';
import MarketPanel from './components/MarketPanel';
import LeaderboardPanel from './components/LeaderboardPanel';
import AdminPanel from './components/AdminPanel';
import SectorPanel from './components/SectorPanel';
import ProductionPanel from './components/ProductionPanel';
import LogisticsPanel from './components/LogisticsPanel';
import CombatPanel from './components/CombatPanel';
import CorporationPanel from './components/CorporationPanel';
import GuidePanel from './components/GuidePanel';

function AppContent() {
  const { loading, error, user } = useGame();

  if (loading) {
    return (
      <div className="hud-loading">
        <div className="loader-ring" />
        <div className="loader-text">INITIALIZING SYSTEMS...</div>
      </div>
    );
  }
  if (error === 'not_authenticated') {
    window.location.href = process.env.REACT_APP_HUB_URL || 'https://njordheim.com/login';
    return null;
  }
  if (error) {
    return (
      <div className="hud-loading">
        <div className="loader-text error-text">⚠ {error}</div>
        <button className="btn btn-glow" onClick={() => window.location.reload()}>RETRY</button>
      </div>
    );
  }

  return (
    <>
      <Header />
      <main className="hud-main">
        <Routes>
          <Route path="/missions" element={<MissionPanel />} />
          <Route path="/fleet" element={<FleetPanel />} />
          <Route path="/stations" element={<StationPanel />} />
          <Route path="/inventory" element={<InventoryPanel />} />
          <Route path="/market" element={<MarketPanel />} />
          <Route path="/leaderboard" element={<LeaderboardPanel />} />
          <Route path="/sectors" element={<SectorPanel />} />
          <Route path="/production" element={<ProductionPanel />} />
          <Route path="/logistics" element={<LogisticsPanel />} />
          <Route path="/combat" element={<CombatPanel />} />
          <Route path="/corporation" element={<CorporationPanel />} />
          <Route path="/guide" element={<GuidePanel />} />
          {user?.is_admin && <Route path="/admin" element={<AdminPanel />} />}
          <Route path="*" element={<Navigate to="/missions" replace />} />
        </Routes>
      </main>
    </>
  );
}

function App() {
  return (
    <GameProvider>
      <StarfieldBackground />
      <AppContent />
    </GameProvider>
  );
}

export default App;
